export const SET_DEALER_ACTIVE = 'SET_DEALER_ACTIVE';
export const RESET_DEALER_ACTIVE = 'RESET_DEALER_ACTIVE';
